export default __webpack_public_path__ + "images/e6abee3fd70ab766d0f6e5d00a58ef05.png";